import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '../services/translate.service';
import {ACTION_SUFFIX} from '../translate.suffix';
import {Observable} from 'rxjs';

@Pipe({
  name: 'cpActionTranslate',
  pure: true
})
export class ActionTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(query: string, args: any[] = []): Observable<string> {
    return this.translateService.transform(
      this.translateService.containsRegisteredTranslateSuffix(query) ? query : query + ACTION_SUFFIX, ...args);
  }
}
